import React from 'react';

const Contact = () => {
    return (
        <section id="contact">
  <div class="containerr">
      <div data-aos="zoom-in" className="common">
      <h2 style={{color:'white'}}>Get In Touch</h2>
    <div className="common-border"></div>
      </div>
    

    <div class="row">
      <div data-aos="fade-right" class="col-md-6">
            <form class="contact-form">
              <div class="form-group">
                <input type="text" class="form-control " placeholder="Your Name"/>
                <br/>
              </div>
              <div class="form-group">
                <input type="number" class="form-control " placeholder="Phone Number"/>
              </div>
              <br/>
              <div class="form-group email-msg">
                <input type="email" class="form-control " placeholder="Email Address"/>
                <br/>
              </div>
              
              
              <div class="form-group email-msg">
                <textarea type="text" class="form-control " rows="4" placeholder="Your Message"></textarea>
                <br/>
              </div>
              <button type="submit" class="btn btn-danger">Send</button>
            </form>
      </div>
      <div data-aos="fade-left" class="col-md-6 contact-info">
        <div class="follow"><b style={{background:'white'}}>Address:</b><i class="fas fa-map-marker-alt"></i>Feni,Chattogram,Bangladesh</div>

     
        <div class="follow"><b style={{background:'white'}}>Phone:</b><i class="fas fa-phone-alt"></i>+8801847438331</div>

      
      
        <div class="follow"><b style={{background:'white'}}>Email:</b><i class="fas fa-envelope-alt"></i>saamiukarim1@gmail.com</div>
        
      </div>
              </div>
             
    </div>
  </section>
  

    );
};

export default Contact;